import React from 'react';
import styles from './Checkbox.module.css';
import HTMLText from '@features/PageBuilder/components/HTMLText';
const {
  Container,
  Checkmark,
  CheckmarkIsCheked,
  CheckmarkDefault,
  CheckboxContainer,
  CheckmarkError,
  SpacingClass,
  NoMargin,
} = styles;

interface CheckboxProps {
  label: string | Element;
  isChecked: boolean;
  handleClick: () => void;
  icon: React.ReactNode;
  hasError?: boolean;
  spacing?: boolean;
}

const Checkbox = ({
  label,
  isChecked,
  handleClick,
  icon,
  hasError,
  spacing,
}: CheckboxProps) => {
  // Check if the clicked element is a link
  const handleCheckboxClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    if ((e.target as HTMLElement).tagName.toLowerCase() === 'a') {
      // If it's a link, stop event propagation
      e.stopPropagation();
    } else {
      // If it's not a link, handle the click event for the checkbox
      handleClick();
    }
  };

  return (
    <div className={`${CheckboxContainer} ${spacing ? SpacingClass : null}`}>
      <div>
        <label className={Container} onClick={(e) => e.stopPropagation()}>
          <input type="checkbox" checked={isChecked} onChange={handleClick} />
          <div className={isChecked ? CheckmarkIsCheked : CheckmarkDefault}>
            <span
              className={`${Checkmark} ${hasError ? CheckmarkError : null}`}
            >
              {isChecked ? icon : null}
            </span>
          </div>
        </label>
      </div>

      <div onClick={(e) => handleCheckboxClick(e)}>
        <HTMLText className={NoMargin}>{label}</HTMLText>
      </div>
    </div>
  );
};

export default Checkbox;
